const moveMaterialToStart = (materials, material) => {
  const materialSku = material?.sku;

  if (materials && materialSku && materials[0]?.sku !== materialSku) {
    const filteredMaterials = materials.filter(
      ({ sku }) => sku !== materialSku
    );

    return [material, ...filteredMaterials];
  }

  return materials;
};

export default moveMaterialToStart;
